import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';

import { ORG_GUID, AppKind, TellentAdminAppConfig } from '@tellent/types';

import { APP_CONFIG } from '@recruitee/common';

// Add supported routes for mapping here
type AppRoute = 'billing' | 'buy_sso';

// used for type guard,
// key: AppRoute, body: Record<string, string | number>
type AppRouteParams = {};

type AppKindParam = AppKind | `${AppKind}`;
type PageConfig<ID extends AppRoute> = ID extends keyof AppRouteParams
  ? {
      id: ID;
      params: AppRouteParams[ID];
    }
  : {
      id: ID;
    };

export function injectTellentAppUrlOpener() {
  const config = inject<TellentAdminAppConfig>(APP_CONFIG);
  const doc = inject(DOCUMENT);
  const _orgGuid = inject(ORG_GUID) ?? undefined;

  return (
    kind: AppKindParam,
    pageConfig?: PageConfig<AppRoute>,
    orgGuid: string | undefined = _orgGuid,
    target: string = '_self',
  ) => doc.defaultView?.open(buildUrl(config.tellentAuthUrl, kind, pageConfig, orgGuid), target);
}

export function injectTellentAppUrlBuilder() {
  const config = inject<TellentAdminAppConfig>(APP_CONFIG);
  return (kind: AppKindParam, pageConfig?: PageConfig<AppRoute>, orgGuid?: string) =>
    buildUrl(config.tellentAuthUrl, kind, pageConfig, orgGuid);
}

function buildUrl<ID extends AppRoute>(
  base: string,
  kind: AppKindParam,
  pageConfig?: PageConfig<ID>,
  orgGuid?: string | null,
) {
  let url = `${base}/switch?app_kind=${kind}`;

  if (orgGuid) {
    url += `&org_guid=${orgGuid}`;
  }

  if (pageConfig) {
    url += `&page=${encodeURIComponent(JSON.stringify(pageConfig))}`;
  }

  return url;
}
